export default __webpack_public_path__ + "images/ip-icon.svg";